import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};

export const removeNonDigits = (inputValue: string) =>
  inputValue.replace(/[^\d]/g, "");

export const convertToFullName = (firstName: string, lastName: string) =>
  `${firstName ? firstName.charAt(0).toUpperCase() + firstName.slice(1) : ""} ${
    lastName ? lastName.charAt(0).toUpperCase() + lastName.slice(1) : ""
  }`.trim();
